/*
  Offset dynamique de la barre de filtres sticky (pages collection, desktop >= 990px).

  Publie --facets-sticky-top = bas RÉEL du header, consommé par component-facets.css.

  Pourquoi : --header-height est codé en dur dans sections/header.liquid (60px, 64px
  au-delà de 950px) et ne correspond qu'à un header sur une seule rangée. Les thèmes
  en disposition "logo au-dessus du menu" (header--top-center) ont un header sur deux
  rangées d'environ 120px : la barre se calait à 64px et passait donc sous le header
  (55px masqués sur 59). Mesurer le header supprime toute valeur en dur.

  On suit le BAS du header et non sa hauteur, pour couvrir aussi l'état "masqué au
  scroll" : le header glisse de -var(--header-height) sans forcément sortir de l'écran,
  il en reste une bande visible dont la barre doit rester dégagée.
*/
(() => {
  const header = document.querySelector('.shopify-section.section-header') || document.querySelector('.header-wrapper');
  const bar = document.querySelector('.facets-wrapper');
  if (!header || !bar) return;

  const root = document.documentElement;
  let last = -1;
  let queued = false;

  const apply = () => {
    queued = false;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    // On n'écrit que sur changement réel : évite un recalcul de style à chaque frame.
    if (bottom === last) return;
    last = bottom;
    root.style.setProperty('--facets-sticky-top', `${bottom}px`);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  };

  apply();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  new ResizeObserver(schedule).observe(header);
  // Le header apparaît/disparaît en transition : on resynchronise à la fin du glissement.
  header.addEventListener('transitionend', schedule);
})();
